import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useAtom } from 'jotai';
import { startCase } from 'lodash';

import Panel from '@/layout/Panel';
import {
  rulesDetailsAtom,
  rulesDetailsExpandedAtom
} from '@/pages/Administration/AdministrationRules';

import useStyles from './RulesDetails.styles';
import { RulesFileActivityLog } from './RulesFileActivityLog';
import { RulesFileContent } from './RulesFileContent';
import { RulesFileDetails } from './RulesFileDetails';

const RulesDetails = () => {
  const [rulesDetails, setRulesDetails] = useAtom(rulesDetailsAtom);
  const [, setAreRulesDetailsExpanded] = useAtom(rulesDetailsExpandedAtom);
  const { classes } = useStyles();

  const handleClose = () => {
    setAreRulesDetailsExpanded(false);
    setRulesDetails(null);
  };

  return (
    <Panel
      title={`${startCase(rulesDetails?.file_type)} Details`}
      onClose={handleClose}
    >
      <Box className={classes.rulesDetailsContentSection}>
        <RulesFileDetails />
      </Box>
      <Divider />
      <Box className={classes.rulesDetailsContentSection}>
        <Typography variant="h6">ACTIVITY LOG</Typography>
        <RulesFileActivityLog />
      </Box>
      <Divider />
      <Box className={classes.rulesDetailsContentSection}>
        <Typography variant="h6">CONTENTS</Typography>
        <RulesFileContent />
      </Box>
    </Panel>
  );
};

export default RulesDetails;
